// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A **continuous interval of time** making up a timetable frame **of 1 year**, typically starting around 2nd Sunday of December.
 * @export
 * @interface OperatingPeriod
 */
export interface OperatingPeriod {
    /**
     * Only set in context of a `ServiceJourney::operatingPeriods`. **Regular service-days a `ServiceProduct` operates** by scheduled plan within the same `OperatingPeriod`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof OperatingPeriod
     */
    daysRegularFormatted?: string;
    /**
     * Only set in context of a `ServiceJourney::operatingPeriods`. **Irregular service-days (or excpetions to regular days) a `ServiceProduct` operates** by scheduled plan within the same `OperatingPeriod`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof OperatingPeriod
     */
    daysIrregularFormatted?: string;
    /**
     * 
     * @type {Set<Date>}
     * @memberof OperatingPeriod
     */
    operatingDays: Set<Date>;
    /**
     * Name of attached model-type having this operating period, like `Trip`, `StopPlace` or `ServiceJourney` (just an informational value).
     * @type {string}
     * @memberof OperatingPeriod
     */
    name: string;
    /**
     * Related to `name=StopPlace` for corresponding data-poolId.
     * @type {string}
     * @memberof OperatingPeriod
     */
    shortName?: string;
    /**
     * In the context of `ServiceJourney` relates to the first `ScheduledStop::routeIndex` where given `operatingDays` are valid, null if unknown.
     * @type {number}
     * @memberof OperatingPeriod
     */
    routeIndexFrom?: number;
    /**
     * In the context of `ServiceJourney` relates to the last `ScheduledStop::routeIndex` where `operatingDays` are valid, null if unknown.
     * @type {number}
     * @memberof OperatingPeriod
     */
    routeIndexTo?: number;
}

/**
 * Check if a given object implements the OperatingPeriod interface.
 */
export function instanceOfOperatingPeriod(value: object): value is OperatingPeriod {
    if (!('operatingDays' in value) || value['operatingDays'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OperatingPeriodFromJSON(json: any): OperatingPeriod {
    return OperatingPeriodFromJSONTyped(json, false);
}

export function OperatingPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatingPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'daysRegularFormatted': json['daysRegularFormatted'] == null ? undefined : json['daysRegularFormatted'],
        'daysIrregularFormatted': json['daysIrregularFormatted'] == null ? undefined : json['daysIrregularFormatted'],
        'operatingDays': new Set(json['operatingDays']),
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'routeIndexFrom': json['routeIndexFrom'] == null ? undefined : json['routeIndexFrom'],
        'routeIndexTo': json['routeIndexTo'] == null ? undefined : json['routeIndexTo'],
    };
}

  export function OperatingPeriodToJSON(json: any): OperatingPeriod {
      return OperatingPeriodToJSONTyped(json, false);
  }

  export function OperatingPeriodToJSONTyped(value?: OperatingPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'daysRegularFormatted': value['daysRegularFormatted'],
        'daysIrregularFormatted': value['daysIrregularFormatted'],
        'operatingDays': Array.from(value['operatingDays'] as Set<any>),
        'name': value['name'],
        'shortName': value['shortName'],
        'routeIndexFrom': value['routeIndexFrom'],
        'routeIndexTo': value['routeIndexTo'],
    };
}

